import CheckoutLayout from "./CheckoutLayout";

export default CheckoutLayout;
